<template>
  <div>
    <div v-if="amortizationItems.length === 0">
      <vs-input label="Fecha primer pago" type="text" v-model="startDate"/>

      <vs-textarea
          class="mt-4"
          :disabled="startDate === null"
          v-model="content"
          placeholder="Copie y pege su tabla en el orden de las columnas."
          @keyup.ctrl.capture="copyTableFromClipboardHandler"></vs-textarea>

      <table>
        <thead>
        <th class="w-1/12">Número</th>
        <th class="w-1/12">Fecha de pago</th>
        <th class="w-1/12">Pago</th>
        <th class="w-1/12">Saldo incial</th>
        <th class="w-1/12">Amortización</th>
        <th class="w-1/12">Interés</th>
        <th class="w-1/12">IVA interés</th>
        <th class="w-1/12">Comisión</th>
        <th class="w-1/12">IVA Comisión</th>
        <th class="w-1/12">Saldo final</th>
        <th class="w-1/12">Pago en efectivo</th>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>
    <div v-else>
      <vs-button class="float-right" @click="saveHandler">Guardar</vs-button>
      <div>
        <table>
          <thead>
          <th class="w-1/12">Número</th>
          <th class="w-1/12">Fecha de pago</th>
          <th class="w-1/12">Pago</th>
          <th class="w-1/12">Saldo incial</th>
          <th class="w-1/12">Amortización</th>
          <th class="w-1/12">Interés</th>
          <th class="w-1/12">IVA interés</th>
          <th class="w-1/12">Comisión</th>
          <th class="w-1/12">IVA Comisión</th>
          <th class="w-1/12">Saldo final</th>
          <th class="w-1/12">Pago en efectivo</th>
          </thead>
          <tbody>
          <tr v-for="amortizationItem in amortizationItems">
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.number" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.paymentDate" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.payment" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.initialBalance" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.amortization" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.interest" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.interestTax" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.commission" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.commissionTax" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.finalBalance" class="w-full"></vs-input>
            </td>
            <td class="w-1/12">
              <vs-input v-model="amortizationItem.cashPayment" class="w-full"></vs-input>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
<script>
import moment from "moment";

const NUMBER = 0;
const PAYMENT_DATE = 1;
const PAYMENT = 2;
const CASH_PAYMENT = 3;
const FINANCED_PAYMENT = 4;
const INITIAL_BALANCE = 5;
const AMORTIZATION = 6;
const INTEREST = 7;
const COMMISSION = 8;
const FINAL_BALANCE = 10;

export default {
  name: "ManualAmortizationForm",
  data: () => ({
    content: null,
    startDate: null,
    amortizationItems: []
  }),
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  methods: {
    numberFormattedToFloat(value) {
      return parseFloat(
          value.replaceAll("$", "")
              .replaceAll(",", "")
      )
    },
    copyTableFromClipboardHandler(ev) {
      const rows = ev.target.value.split("\n")
      const table = rows.map(row => {
        return row.split("\t")
      })

      let nextPaymentDate = moment(this.startDate)
      // build amortization items
      for (const row of table) {
        this.amortizationItems.push({
          number: row[NUMBER],
          paymentDate: nextPaymentDate.format("YYYY-MM-DD"),
          payment: this.numberFormattedToFloat(row[PAYMENT]),
          cashPayment: this.numberFormattedToFloat(row[CASH_PAYMENT]),
          financedPayment: this.numberFormattedToFloat(row[FINANCED_PAYMENT]),
          initialBalance: this.numberFormattedToFloat(row[INITIAL_BALANCE]),
          amortization: this.numberFormattedToFloat(row[AMORTIZATION]),
          interest: this.numberFormattedToFloat(row[INTEREST]),
          interestTax: this.numberFormattedToFloat(row[INTEREST]) * 0.16,
          commission: this.numberFormattedToFloat(row[COMMISSION]),
          commissionTax: this.numberFormattedToFloat(row[COMMISSION]) * 0.16,
          finalBalance: this.numberFormattedToFloat(row[FINAL_BALANCE])
        })

        nextPaymentDate = nextPaymentDate.add(1, "month")
      }
    },
    async saveHandler() {
      this.showLoading(true)
      try {
        await axios.post(`/api/project/${this.projectId}/amortization/manual`, {
          items: this.amortizationItems
        })
        this.$emit("onSuccess", {items: this.amortizationItems})
      } catch (e) {
        this.$emit("onFailed", {message: "Hubo un error al guardar la tabla de amortización"})
        this.showLoading(false)
      } finally {
        this.showLoading(false)
      }
    }
  }
}
</script>
<style scoped>

</style>